// English locale imports
import commonEn from "./en/common.json";
import navigationEn from "./en/navigation.json";
import authEn from "./en/auth.json";
import dashboardEn from "./en/dashboard.json";
import catalogEn from "./en/catalog.json";
import crmEn from "./en/crm.json";
import salesEn from "./en/sales.json";
import marketingEn from "./en/marketing.json";
import aidaEn from "./en/aida.json";
import conversationsEn from "./en/conversations.json";
import settingsEn from "./en/settings.json";
import integrationsEn from "./en/integrations.json";
import knowledgeEn from "./en/knowledge.json";
import onboardingEn from "./en/onboarding.json";
import analyticsEn from "./en/analytics.json";
import adminEn from "./en/admin.json";
import creditsEn from "./en/credits.json";
import automationsEn from "./en/automations.json";
import googleCalendarEn from "./en/google-calendar.json";

// Arabic locale imports
import commonAr from "./ar/common.json";
import navigationAr from "./ar/navigation.json";
import authAr from "./ar/auth.json";
import dashboardAr from "./ar/dashboard.json";
import catalogAr from "./ar/catalog.json";
import crmAr from "./ar/crm.json";
import salesAr from "./ar/sales.json";
import marketingAr from "./ar/marketing.json";
import aidaAr from "./ar/aida.json";
import conversationsAr from "./ar/conversations.json";
import settingsAr from "./ar/settings.json";
import integrationsAr from "./ar/integrations.json";
import knowledgeAr from "./ar/knowledge.json";
import onboardingAr from "./ar/onboarding.json";
import analyticsAr from "./ar/analytics.json";
import adminAr from "./ar/admin.json";
import creditsAr from "./ar/credits.json";
import automationsAr from "./ar/automations.json";
import googleCalendarAr from "./ar/google-calendar.json";

export const resources = {
  en: {
    translation: {
      ...commonEn,
      ...navigationEn,
      ...authEn,
      ...dashboardEn,
      ...catalogEn,
      ...crmEn,
      ...salesEn,
      ...marketingEn,
      ...aidaEn,
      ...conversationsEn,
      ...settingsEn,
      ...integrationsEn,
      ...knowledgeEn,
      ...onboardingEn,
      ...analyticsEn,
      ...adminEn,
      ...creditsEn,
      ...automationsEn,
      ...googleCalendarEn,
    },
  },
  ar: {
    translation: {
      ...commonAr,
      ...navigationAr,
      ...authAr,
      ...dashboardAr,
      ...catalogAr,
      ...crmAr,
      ...salesAr,
      ...marketingAr,
      ...aidaAr,
      ...conversationsAr,
      ...settingsAr,
      ...integrationsAr,
      ...knowledgeAr,
      ...onboardingAr,
      ...analyticsAr,
      ...adminAr,
      ...creditsAr,
      ...automationsAr,
      ...googleCalendarAr,
    },
  },
};
